import type { QuestionTypeRendererProps } from "./shared";
import ShortAnswerQuestionType from "./short-answer";
import LongAnswerQuestionType from "./long-answer";
import MultipleChoiceQuestionType from "./multiple-choice";
import MultipleAnswerQuestionType from "./multiple-answer";
import DropdownQuestionType from "./dropdown";
import RatingQuestionType from "./rating";
import ScaleQuestionType from "./scale";
import NumberQuestionType from "./number";
import DateQuestionType from "./date";
import TimeQuestionType from "./time";
import DateTimeQuestionType from "./datetime";
import FileUploadQuestionType from "./file-upload";
import EmailQuestionType from "./email";
import PhoneQuestionType from "./phone";
import YesNoQuestionType from "./yes-no";
import MultipleChoiceGridQuestionType from "./multiple-choice-grid";
import CheckboxGridQuestionType from "./checkbox-grid";

export { noopRendererProps } from "./shared";

export const QUESTION_TYPE_COMPONENTS = {
  short_answer: ShortAnswerQuestionType,
  long_answer: LongAnswerQuestionType,
  multiple_choice: MultipleChoiceQuestionType,
  multiple_answer: MultipleAnswerQuestionType,
  dropdown: DropdownQuestionType,
  rating: RatingQuestionType,
  scale: ScaleQuestionType,
  number: NumberQuestionType,
  date: DateQuestionType,
  time: TimeQuestionType,
  datetime: DateTimeQuestionType,
  file_upload: FileUploadQuestionType,
  email: EmailQuestionType,
  phone: PhoneQuestionType,
  yes_no: YesNoQuestionType,
  multiple_choice_grid: MultipleChoiceGridQuestionType,
  checkbox_grid: CheckboxGridQuestionType,
} as const;

export type SurveyQuestionTypeComponentKey = keyof typeof QUESTION_TYPE_COMPONENTS;

export type { QuestionTypeRendererProps };
export { validateSurveyQuestion, validateSurveyQuestions } from "./validation";
